import { observer } from "mobx-react";
import React, { useState } from "react";
import { PositionedSpinner } from "../../../../../../components/ui/PositionedSpinner";
import { SingleForm } from "../../../../../change/forms/singleFormModel/SingleForm_view";
import { useCurrentOrganisationId } from "../../../../../../services/local/organisationContext/OrganisationContextModel";
import { useParams } from "react-router-dom";
import { ImpactBusinessAreasSidebarModel } from "./ImpactBusinessAreasSidebar_model";

export interface ImpactBusinessAreasSidebarProps {
  onSubmit: (businessAreaIds: number[]) => void;
}

export const ImpactBusinessAreasSidebar: React.FC<ImpactBusinessAreasSidebarProps> = observer(({ onSubmit }) => {
  const organisationId = useCurrentOrganisationId();
  const { projectId } = useParams();
  const [model] = useState(() => new ImpactBusinessAreasSidebarModel(organisationId, +projectId, onSubmit));
  if (model.isLoading) return <PositionedSpinner />;

  return (
    <div className="container-fluid">
      <SingleForm model={model.formModel} />
    </div>
  );
});
